import React, { Component } from 'react';
import update from 'immutability-helper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../redux/actions';
import InventoryUtils from '../../utils/inventory-utils';
import serviceUtils from '../../utils/service-utils';
import { TravcoHotelAutocomplete } from 'travco-hotel-autocomplete';
import { TravcoButtonGroup } from 'travco-button-group';
import SearchDataTable from './search-table';
import { TravcoFieldLabel } from 'travco-field-label';
import Select from 'react-select';

export class SearchContainer extends Component {
	constructor(props) {
		super(props);
		this.state = this.getInitialState();
		this.fireSearch = this.fireSearch.bind(this);
		this.search = this.search.bind(this);
		this.onChange = this.onChange.bind(this);
		this.clearPage = this.clearPage.bind(this);
		this.hotelChange = this.hotelChange.bind(this);
	}

	getInitialState() {
		return {
			hotelId: '',
			pageNumber: 1,
			pageSize: -1,
			defaultPageSize: 10,
			selectedInventoryStatus: 0,
			selectedInventoryLabel: ''
		};
	}

	componentDidMount() {
		this.setState({
			settings: this.props.settings
		});

		if (
			(this.props.model.inventory && this.props.model.inventory?.hotel?.id) ||
			(this.props.model.hotel && this.props.model.hotel.id)
		) {
			const hotelId = this.props.model.inventory
				? this.props.model.inventory.hotel.id
				: this.props.model.hotel.id;
			const request = update(
				{},
				{
					hotelId: { $set: hotelId },
					pageNumber: { $set: 1 },
					pageSize: { $set: this.state.pageSize },
					defaultPageSize: { $set: this.state.defaultPageSize }
				}
			);
			this.setGlobalInfo(this.props.model.inventory.hotel);
			this.props.actions.searchInventory(request);
			// this.hotelChange(this.props.model.inventory ? this.props.model.inventory.hotel : this.props.model.hotel);
		}
	}

	datesChange(startDate, endDate) {
		let state = update(this.state, {
			search: {
				dateFrom: { $set: startDate ? startDate.toISOString() : null },
				dateTo: { $set: endDate ? endDate.toISOString() : null }
			}
		});
		this.setState(state);
	}

	onFilterChange(level, data) {
		let inventory = update(this.props.inventory, {
			[level]: { filter: { $set: data }, items: { $set: [] } }
		});

		this.props.actions.setPolicy(inventory).then(p => {
			if (p[level] && p[level].filter) {
				this.props.actions.searchPolicy({ [level]: p[level].filter, pageSize: 1 }, level);
			}
		});
	}

	onSave() {
		this.props.actions.saveInventory(this.props.inventory).then(data => {
			console.log(data);
		});
	}

	clearPage() {
		this.hotelChange('');
		let state = update(this.state, {
			selectedInventoryStatus: { $set: 0 }
		});
		this.setState(state);
	}

	hotelChange(value) {
		const { actions, model } = this.props;

		let clearedObject = { ...model.inventory, hotel: value };

		if (value) {
			clearedObject.roomCategoryId = '';
			clearedObject.roomCategoryName = '';
		}

		let modelObj = Object.assign({}, model, {
			inventory: clearedObject,
			inventorySearchData: value == '' ? [] : this.props.model.inventory.inventorySearchData
		});

		this.setState({
			hotelId: value ? value.id : ''
		});

		this.setGlobalInfo(value);

		actions.setModelObject(modelObj);
	}

	setGlobalInfo(hotel) {
		const { actions, headerInfo } = this.props;
		let newData = [
			{ name: 'Country', data: hotel ? hotel.country.name : null },
			{
				name: 'Region',
				data: hotel && hotel.city.primaryCountryRegion ? hotel.city.primaryCountryRegion.name : null
			},
			{ name: 'City', data: hotel ? hotel.city.name : null },
			{
				name: 'Hotel',
				data: hotel ? `${hotel.name} ( ${hotel.code} )` : null
			},
			{
				name: 'Currency',
				data: hotel && hotel.currency ? hotel.currency.isoCode : null
			},
			{ name: 'Room category', data: null }
		];
		const newHeaderInfo = serviceUtils.processHeaderInfo(newData, headerInfo);

		actions.setHeaderInfo(newHeaderInfo);
		actions.setGlobalHotel(hotel);
	}

	onChange(property, value, callback) {
		let state = Object.assign({}, this.state);
		state[property] = value;
		this.setState(state, callback);
	}

	onInventoryStatusChange(selectedOption) {
		if (selectedOption !== 0) {
			this.setState(
				update(this.state, {
					selectedInventoryStatus: { $set: selectedOption?.value },
					selectedInventoryLabel: { $set: selectedOption?.label }
				})
			);
		} else {
			this.setState(
				update(this.state, {
					selectedInventoryStatus: { $set: 0 },
					selectedInventoryLabel: { $set: '' }
				})
			);
		}
	}

	fireSearch(pageData) {
		let state = Object.assign({}, this.state);
		let request = update(
			{},
			{
				hotelId: { $set: state.hotelId },
				pageNumber: { $set: pageData ? pageData.pageNumber : state.pageNumber },
				pageSize: { $set: this.state.pageSize },
				defaultPageSize: { $set: this.state.defaultPageSize },
				selectedInventoryStatus: { $set: this.state.selectedInventoryStatus }
			}
		);

		if (request.hotelId.length > 0) {
			this.props.actions.searchInventory(request);
		}
	}

	search() {
		this.onChange('pageNumber', 1, this.fireSearch());
		this.setState(update(this.state, { searchedClicked: { $set: true } }));
	}

	render() {
		const iventoryStatusOptions = [
			{
				label: 'Active',
				value: 1
			},
			{
				label: 'Inactive',
				value: 2
			}
		];

		return (
			<div>
				<div
					className={`travco-search-header ${
						this.props.headerInfo.length > 0 ? 'hotel-selected' : ''
					}`}>
					<div className="travco-body">
						<h1 style={{ marginLeft: '26px' }}>Search Inventory</h1>
						<div className="travco-grid-fluid gutter">
							<div className="tg-cell-2-8">
								<div className="content search-hotel">
									<TravcoHotelAutocomplete
										id="hotel-dd"
										label="Hotel"
										searchable={true}
										hotelApiUrl={this.props.settings.hotelApiUrl}
										selectedHotel={
											this.props.model.inventory.hotel !== null &&
											Object.keys(this.props.model.inventory.hotel).length > 0
												? this.props.model.inventory.hotel
												: null
										}
										onChange={this.hotelChange}
										disabled={this.props.readOnly}
										clearable={true}
										token={this.props.token}
										className="z-index4"
									/>
								</div>
							</div>
							<div className="tg-cell-2-8">
								<TravcoFieldLabel>Status</TravcoFieldLabel>
								<Select
									options={iventoryStatusOptions}
									isClearable={true}
									onChange={this.onInventoryStatusChange.bind(this)}
									value={
										this.state.selectedInventoryStatus !== 0 ||
										this.state.selectedInventoryStatus === 'undefined'
											? {
													label: this.state.selectedInventoryLabel,
													value: this.state.selectedInventoryStatus
											  }
											: null
									}
								/>
							</div>
							<div className="tg-cell-2-8">
								<div className="content search-cancel">
									<TravcoButtonGroup
										buttons={[
											{
												text: 'Search',
												className: 'btn-primary search',
												icon: 'glyphicon-search',
												handler: this.search
											},
											{
												text: 'Clear',
												className: 'btn-dark clear',
												icon: 'glyphicon-remove-circle',
												handler: this.clearPage
											}
										]}
									/>
								</div>
							</div>
							<div className="tg-cell">
								<div className="content" />
							</div>
						</div>
					</div>
				</div>
				<div className="travco-body">
					{this.props.userType === 'Travco' && (
						<button
							name="btnNewInventory"
							id="create-new-inventory-btn"
							className="travco-btn-secondary"
							onClick={this.props.onCreateInventory}>
							<span className="glyphicon glyphicon-plus" />
							 Create New Inventory
						</button>
					)}
					<SearchDataTable
						inventoryData={this.props.model.inventoryDataFiltered}
						onRemoveInventory={this.props.onRemoveInventory}
						onRowSelected={InventoryUtils.rowSelected}
						onSave={this.props.onSave}
						onEditClick={this.props.onEditClick}
						isModal={false}
						onChange={this.onChange}
						fireSearch={this.fireSearch}
						pageSize={this.state.pageSize}
					/>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	let pager = {
		pageSize: 5,
		totalPages: 0,
		pageNumber: 0,
		visiblePages: 9,
		titles: { first: 'First', last: 'Last' }
	};

	if (state.model.inventorySearchData) {
		Object.assign(pager, {
			pageNumber: state.model.pageNumber - 1,
			totalPages: Math.ceil(
				Math.min(state.model.totalItemCount / pager.pageSize, 10000 / pager.pageSize)
			)
		});
	}

	return {
		oidc: state.oidc,
		token: state.oidc.user !== null ? state.oidc.user.id_token : '',
		settings: state.settings,
		model: state.model,
		pager: pager,
		userType: state.oidc && state.oidc.user && state.oidc.user.profile['travco_user_type'],
		headerInfo:
			state.globalData.headerInfo && state.globalData.headerInfo[0].data
				? state.globalData.headerInfo
				: []
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);
